/** Keep an editable decimal separator and convert to cents only at the boundary. */
export function parseDonationAmount(value) {
  let text = value.replace(/[^\d.,]/g, '');
  // Accept Brazilian currency pasted with thousands separators, and decimal
  // points from mobile keyboards. Always display a comma while editing.
  text = text.includes(',') ? text.replace(/\./g, '') : text.replace('.', ',');
  const [whole, ...fractionParts] = text.split(',');
  const fraction = fractionParts.join('').replace(/\./g, '').slice(0, 2);
  const hasSeparator = fractionParts.length > 0;

  return {
    text: whole + (hasSeparator ? `,${fraction}` : ''),
    cents: Number(whole || 0) * 100 + Number(fraction.padEnd(2, '0'))
  };
}
